module.exports = __webpack_public_path__ + "img/lanscape-1.75226d5c.webp";